import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="This page provides LTI resource keys for your selected partner, including <strong>practice tests</strong>, <strong>custom tests</strong>, and <strong>courses</strong>." id="this_page_provides_lti_resource_keys_for.49852f85" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="LTI Resource Keys" id="lti_resource_keys.18a6c604" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Test Keys</strong> tab to browse category and product test controls, and the <strong>Course Keys</strong> tab to view course controls and download Common Cartridge files when available." id="use_the_test_keys_tab_to_browse_category.2edfe30a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Tabs and Key Types" id="tabs_and_key_types.9c63993e" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Request LTI Key and Secret</strong> to generate credentials for the selected partner. The credentials dialog also includes the <strong>LTI Advantage dynamic registration URL</strong>, which can be copied directly to your clipboard." id="click_request_lti_key_and_secret_to_gene.2c1f0658" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Credentials and Registration" id="credentials_and_registration.8218325b" />
        }
    ],
    title: <FormattedMessage defaultMessage="LTI Resource Keys" id="lti_resource_keys.18a6c604" />
};
